export default function uniq(array) {
  const uniquedArray = []
  for (const elem of array) {
    if (uniquedArray.indexOf(elem) < 0) uniquedArray.push(elem)
  }
  return uniquedArray
}
